export default __webpack_public_path__ + "static/media/VinyasH.45ce57e5.jpg";